import Icon from "@ant-design/icons";

const WarningSvg = () => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6 11C7.3807 11 8.6307 10.4404 9.53553 9.53553C10.4404 8.6307 11 7.3807 11 6C11 4.6193 10.4404 3.3693 9.53553 2.46446C8.6307 1.55964 7.3807 1 6 1C4.6193 1 3.3693 1.55964 2.46446 2.46446C1.55964 3.3693 1 4.6193 1 6C1 7.3807 1.55964 8.6307 2.46446 9.53553C3.3693 10.4404 4.6193 11 6 11Z"
      stroke="currentColor"
      strokeLinejoin="round"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6 9.25C6.34518 9.25 6.625 8.97018 6.625 8.625C6.625 8.27983 6.34518 8 6 8C5.65483 8 5.375 8.27983 5.375 8.625C5.375 8.97018 5.65483 9.25 6 9.25Z"
      fill="currentColor"
    />
    <path
      d="M6 3V7"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const WarningIcon = (props) => (
  <Icon
    component={WarningSvg}
    {...props}
  />
);

export default WarningIcon;
